module.exports = "/_next/static/images/fdf0669152971a6a9045ca4a4451b981-apply-bullet-1.jpeg.webp";